import { PortableTextBlockComponent } from '@portabletext/react'
import React from 'react'
import { getBlockStyleWithFallback } from '../../../../utilities/portableText'

/**
 * Compact "serializer" (renderer) for standard "blocks" (i.e. rich text)
 * Does not apply styling for text and color. Assumes paragraph text style is set on parent element.
 */
export const BasicBlockSerializer: PortableTextBlockComponent = ({ children, value }) => {
  let HtmlElement: keyof JSX.IntrinsicElements | null = null
  let classes: string | undefined = undefined

  if (!value) {
    return null
  }

  const style = getBlockStyleWithFallback(value.style)

  switch (style) {
    case 'normal':
      HtmlElement = 'p'
      classes = 'mb-30 last:mb-0'
      break

    default:
      // In most use cases, the "style" maps to an actual HTML tag name
      HtmlElement = style as keyof JSX.IntrinsicElements
      break
  }

  return <HtmlElement className={classes}>{children}</HtmlElement>
}
